import React, { useState } from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import { SWRConfig } from 'swr';

import config from 'app.config';
import loadablePage from 'components/loadablePage';
import LayoutWrapper from 'components/LayoutWrapper';
import { UserContext, SetUserContext, userDefaultValue } from 'routes/login/userContext';
import { ConfigProvider, ThemeConfig, App as AntdApp } from 'antd';
import useDSSNotification from 'hooks/useDSSNotification';
import 'antd/dist/reset.css';
import './index.css';

const { publicUrl } = config;

const UserProvider = UserContext.Provider;
const SetUserProvider = SetUserContext.Provider;
const theme: ThemeConfig = {
  token: {
    lineHeight: 1.5,
    colorPrimary: '#ee4d2d',
    colorInfo: '#ee4d2d',
    colorError: '#ee2c4a',
    colorWarning: '#f69113',
    colorSuccess: '#30b566',
    borderRadius: 4,
    colorBgMask: '#00000066',
    colorPrimaryBorderHover: '#f7a696',
    colorPrimaryBg: '#fef6f5',
  },
  components: {
    Button: {
      colorLink: '#0088FF',
      colorLinkHover: '#52BAFF',
    },
    Rate: {
      yellow6: '#eda500',
    },
  },
};

function App() {
  const [user, setUser] = useState(userDefaultValue);
  const { showError } = useDSSNotification();
  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
        shouldRetryOnError: false,
        onError: (e) => showError(e, '發生錯誤'),
      }}
    >
      <UserProvider value={user}>
        <SetUserProvider value={setUser}>
          <BrowserRouter>
            <Switch>
              <Route exact path={`${publicUrl}/login`} component={loadablePage.login} />
              <Route render={(matchProps) => <LayoutWrapper />} />
            </Switch>
          </BrowserRouter>
        </SetUserProvider>
      </UserProvider>
    </SWRConfig>
  );
}

function AppWrapper() {
  return (
    <ConfigProvider theme={theme}>
      <AntdApp>
        <App />
      </AntdApp>
    </ConfigProvider>
  );
}

export default AppWrapper;
